export * from './components';
// eslint-disable-next-line no-undef
export const version = typeof __VERSION__ === 'undefined' ? '' : __VERSION__;
